import React from 'react';
import { getLocator, isSafariBrowser, isMobileWeb } from '@tcp/core/src/utils';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Modal from '@tcp/core/src/components/common/molecules/Modal/index.js';
import { modalStyles } from '@tcp/core/src/components/common/organisms/QuickViewModal/styles/QuickViewModalModalAnimation.style.js';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import { getDynamicLabelValues, renderLabel } from '@tcp/core/src/utils/labels/labelUtilty';
import styles from '../styles/PriceDropNotificationModal.style';
import DamImage from '../../../../../../common/atoms/DamImage';
import config from '../../../../../../common/molecules/ProductDetailImage/config';
import PriceDropIcon from './PriceDropIcon';

const PriceDropNotificationModal = (props) => {
  const { isOpen, closeModal, className, cartProducts, sflProducts } = props;
  const onCloseClick = () => {
    closeModal(false);
  };
  const modalHeadingNewQV = {
    className: 'modal-heading',
  };
  const isSafari = isSafariBrowser();

  const filteredCartProducts = Array.isArray(cartProducts)
    ? cartProducts.filter((product) => product?.itemInfo?.lastViewedPrice > 0)
    : [];

  const filteredSflProducts = Array.isArray(sflProducts)
    ? sflProducts.filter((product) => product?.itemInfo?.lastViewedPrice > 0)
    : [];

  const combinedFilteredProducts = filteredCartProducts
    ? filteredCartProducts.concat(filteredSflProducts)
    : [];

  const { badgeConfig } = config.IMG_DATA_CLIENT_BAGPAGE;

  const bagHeading = renderLabel(
    getDynamicLabelValues('dynamic.cart.lbl_priceDrop_modal_product_bag'),
    'lbl_priceDrop_modal_product_bag'
  );

  const sflHeading = renderLabel(
    getDynamicLabelValues('dynamic.cart.lbl_priceDrop_modal_product_sfl'),
    'lbl_priceDrop_modal_product_sfl'
  );

  return (
    <div>
      <Modal
        fixedWidth
        isOpen={isOpen}
        onRequestClose={() => {
          onCloseClick();
        }}
        heading={renderLabel(
          getDynamicLabelValues('dynamic.cart.lbl_priceDrop_modal_header'),
          'lbl_priceDrop_modal_header'
        )}
        headingAlign="center"
        overlayClassName="TCPModal__Overlay"
        dataLocator={getLocator('PriceDropNotificationModal_modal')}
        dataLocatorHeader={getLocator('price_drop_notification_add_to_bag_header')}
        closeIconDataLocator={getLocator('price_drop_notification_icon_btn')}
        className={`TCPModal__Content, ${className}`}
        inheritedStyles={modalStyles}
        innerContentClassName={`atb-innerContent cart-offers-modal`}
        headingFontWeight="bold"
        headingFontFamily="secondary"
        isSafari={isSafari}
        stickyHeader
        fontSize="fs22"
        headingStyle={modalHeadingNewQV}
      >
        <div className="modal-content">
          {combinedFilteredProducts?.length > 0 && (
            <ul>
              {combinedFilteredProducts.map((product) => (
                <li key={product?.productInfo?.name} className="price-drop-item">
                  <div className="product-container">
                    <DamImage
                      imgData={{
                        alt: `${product?.productInfo?.name}`,
                        url: product?.productInfo?.imagePath,
                      }}
                      imgConfigs={[
                        't_t_cart_item_tile_m',
                        't_t_cart_item_tile_t',
                        't_t_cart_item_tile_d',
                      ]}
                      isProductImage
                      className="price-drop-product-image"
                      tcpStyleType={product?.productInfo?.tcpStyleType}
                      badgeConfig={badgeConfig}
                      itemBrand={product?.productInfo?.itemBrand}
                      primaryBrand={product?.productInfo?.itemBrand}
                    />
                    <div className="product-details">
                      <div className="product-details-section">
                        <BodyCopy
                          className="product-category"
                          fontFamily="secondary"
                          component="span"
                          fontSize={isMobileWeb() ? 'fs11' : 'fs13'}
                          fontWeight="medium"
                        >
                          {product?.source === 'cart' ? bagHeading : sflHeading}
                        </BodyCopy>
                        <div className="product-name-price">
                          <BodyCopy
                            className="product-name"
                            fontFamily="secondary"
                            component="span"
                            fontSize={isMobileWeb() ? 'fs12' : 'fs16'}
                            fontWeight="medium"
                          >
                            {product?.productInfo?.name}
                          </BodyCopy>
                          <div className="price-drop-container">
                            <PriceDropIcon />
                            <BodyCopy
                              className="price-label product-price"
                              fontFamily="secondary"
                              component="span"
                              fontSize={isMobileWeb() ? 'fs14' : 'fs16'}
                              fontWeight={['extrabold']}
                              dataLocator={getLocator('cart_item_total_price')}
                            >
                              <PriceCurrency
                                price={Number(
                                  product?.itemInfo?.itemUnitPrice || product?.itemInfo?.offerPrice
                                )}
                              />
                            </BodyCopy>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Modal>
    </div>
  );
};

PriceDropNotificationModal.defaultProps = {
  className: '',
};

PriceDropNotificationModal.propTypes = {
  className: PropTypes.string,
};

export default withStyles(PriceDropNotificationModal, styles);
export { PriceDropNotificationModal as PriceDropNotificationModalVanilla };
